// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "./Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";

function request() {
  return Future.map(FuturePromise.fromPromise(fetch("https://api64.ipify.org/?format=json", {
    method: "GET"
  }).then(prim => prim.json()).then(json => Promise.resolve(Json.flatDecodeDictFieldString(Json.decodeDict(json), "ip")))), undefined, result => {
    if (result.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let ip = result._0;
    if (ip !== undefined) {
      return {
        TAG: "Ok",
        _0: ip
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
}

export {
  request,
}
/* No side effect */
